module.exports = __webpack_public_path__ + "static/img/grass.2c0b2d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/grass.png
// module id = 5zB8
// module chunks = 4